import Enum from "../../../enums/Enum";

const EnumIdType = new Enum({
    ID: {name: "ID"},
    PASSPORT: {name: "Passport"},
    DRIVER_LICENSE: {name: "Driver's License"},
    GCC_ID: {name: "GCC ID"},
    OTHER: {name: "Other"}
});

export default EnumIdType;